type Props = {
  className?: string
}
export const TrianglesSharp: React.FC<Props> = ({ className }) => (
  <div className={className}>
    <div className='relative h-full w-full'>
      <svg
        width='80'
        height='68'
        viewBox='0 0 80 68'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect
          x='58.3848'
          y='31'
          width='26'
          height='26'
          rx='1'
          transform='rotate(45 58.3848 31)'
          fill='#FC3C3C'
        ></rect>
        <rect
          x='63.5557'
          width='22'
          height='22'
          rx='1'
          transform='rotate(45 63.5557 0)'
          fill='#FC3C3C'
        ></rect>
        <rect
          x='28.2842'
          y='0.142578'
          width='40'
          height='40'
          rx='2'
          transform='rotate(45 28.2842 0.142578)'
          fill='#FC3C3C'
        ></rect>
      </svg>
    </div>
  </div>
)
